import { API_ROOT, API_SECRET } from '../constants/general'

class Fetch {

    static post = (url, params) => {

        let data = fetch(API_ROOT + url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                id_user: localStorage.getItem('idU'),
                app_token: localStorage.getItem('app_token'),
                ...params
            })
               
        }).then(function (response) {
            return response.json()
        }).then(function (data) {
            
            return data

        })

        return data

    }

    static get = (url) => {

        let data = fetch(API_ROOT + url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
               
        }).then(function (response) {
            return response.json()
        }).then(function (data) {
            
            return data

        })

        return data

    }

}

export default Fetch